import { render, staticRenderFns } from "./coupons_gale.vue?vue&type=template&id=61c9a6cf"
import script from "./coupons_gale.vue?vue&type=script&lang=js"
export * from "./coupons_gale.vue?vue&type=script&lang=js"
import style0 from "./coupons_gale.vue?vue&type=style&index=0&id=61c9a6cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports